<template>
  <el-dialog
    title="账单信息"
    :visible.sync="dialogVisible"
    :close-on-click-modal="closeModal"
    :close-on-press-escape="closeEscape"
    :before-close="close"
    :append-to-body="true"
    width="960px"
  >
    <div class="pending-confirm-detail-wrapper">
      <!-- <div class="detail-handler">
        <download-button :downloadApi="exportPendingConfirmBillDetails" :queryParams="downloadParams" @onChangePage="close"></download-button>
        <div class="tips">提示：历史账单暂无明细及可能存在油品字段为空，如需明细，请联系能链商务人员</div>
      </div> -->
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        style="width: 100%"
      >
        <el-table-column prop="id" align="center" label="结算单ID" min-width="100"></el-table-column>
        <el-table-column prop="billDay" align="center" label="账单日期" min-width="110"></el-table-column>
        <el-table-column prop="gasName" align="center" label="油站" min-width="120"></el-table-column>
        <el-table-column prop="oilSpuName" align="center" label="油品" min-width="100"></el-table-column>
        <el-table-column prop="invoiceAmount" align="center" label="油站应开发票总金额(元)" min-width="130"></el-table-column>
        <el-table-column prop="signBodyName" align="center" label="签约主体" min-width="100"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.pageIndex"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import dialog from '@mix/dialog'
import { billingInformation, exportPendingConfirmBillDetails } from '@/api/finance'

export default {
  name: 'PendingConfirmDetailDialog',
  mixins: [dialog],
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: false,
      exportPendingConfirmBillDetails,
      tableData: [],
      pagination: {
        pageIndex: 1,
        pageSize: 10
      },
      total: 0
    }
  },
  computed: {
    downloadParams () {
      return {
        id: this.data.id,
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize
      }
    }
  },
  created () {
    this.getList()
  },
  methods: {
    async getList () {
      try {
        this.loading = true
        const { code, result = [], totalRow = 0 } = await billingInformation({
          id: this.data.id,
          pageIndex: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize
        })
        if (code !== 200) {
          this.tableData = []
          this.total = 0
          return
        }
        this.tableData = result
        this.total = parseInt(totalRow) || 0
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.pagination.pageIndex = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.pagination.pageIndex = val
      this.getList()
    }
  }
}
</script>

<style lang="less" scoped>
.pending-confirm-detail-wrapper {
  .detail-handler {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .tips {
      margin-left: 20px;
      color: #606266;
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
